<template>
    <div class="scroll_wrap" :style="scrollStyle">
        <div class="list_wrap">
            <Scroll ref="scroll" :scrollbar="scrollbarObj" :pullDownRefresh="pullDownRefreshObj" :pullUpLoad="pullUpLoadObj" :startY="parseInt(startY)" @pullingDown="onPullingDown" @pullingUp="onPullingUp">
                <slot></slot>
            </Scroll>
        </div>
    </div>
</template>
<script>
import { ease } from "../config/ease.js";

export default {
    data() {
        return {
            scrollbar: false,
            scrollbarFade: true,
            pullDownRefresh: true, //下拉刷新
            pullDownRefreshThreshold: 90,
            pullDownRefreshStop: 40,
            pullDownRefreshTxt: this.$t("common.refreshed"), //刷新成功
            pullUpLoad: true, //加载更多
            pullUpLoadThreshold: 0,
            pullUpLoadMoreTxt: this.$t("common.LoadMore"), //加载更多
            pullUpLoadNoMoreTxt: this.$t("common.noMore"), //没有更多数据了
            startY: 0,
            scrollToX: 0,
            scrollToY: -200,
            scrollToTime: 700,
            scrollToEasing: "bounce",
            scrollToEasingOptions: ["bounce", "swipe", "swipeBounce"]
        };
    },
    props: {
        scrollStyle: {
            type: String,
            default: "top:0"
        }
    },
    created() {},
    components: {},
    watch: {
        scrollbarObj: {
            handler() {
                this.rebuildScroll();
            },
            deep: true
        },
        pullDownRefreshObj: {
            handler() {
                this.rebuildScroll();
            },
            deep: true
        },
        pullUpLoadObj: {
            handler() {
                this.rebuildScroll();
            },
            deep: true
        },
        // pullDownRefreshObj: {
        //     handler(val) {
        //         const scroll = this.$refs.scroll.scroll
        //         console.log(scroll)
        //         if (val) {
        //             scroll.openPullDown()
        //         } else {
        //             scroll.closePullDown()
        //         }
        //     },
        //     deep: true
        // },
        // pullUpLoadObj: {
        //     handler(val) {
        //         const scroll = this.$refs.scroll.scroll
        //         if (val) {
        //             scroll.openPullUp()
        //         } else {
        //             scroll.closePullUp()
        //         }
        //     },
        //     deep: true
        // },
        startY() {
            this.rebuildScroll();
        }
    },
    computed: {
        scrollbarObj: function() {
            return this.scrollbar ? { fade: this.scrollbarFade } : false;
        },
        pullDownRefreshObj: function() {
            return this.pullDownRefresh ?
                {
                    threshold: parseInt(this.pullDownRefreshThreshold),
                    stop: parseInt(this.pullDownRefreshStop),
                    txt: this.pullDownRefreshTxt
                } :
                false;
        },
        pullUpLoadObj: function() {
            return this.pullUpLoad ?
                {
                    threshold: parseInt(this.pullUpLoadThreshold),
                    txt: {
                        more: this.pullUpLoadMoreTxt, //加载更多
                        noMore: this.pullUpLoadNoMoreTxt //没有更多了
                    }
                } :
                false;
        }
    },
    methods: {
        scrollTo() {
            this.$refs.scroll.scrollTo(
                this.scrollToX,
                this.scrollToY,
                this.scrollToTime,
                ease[this.scrollToEasing]
            );
        },
        onPullingDown() {
            // console.log('下拉刷新')
            // 模拟更新数据
            this.$emit("pullingDown");
        },
        onPullingUp() {
            // 更新数据
            // console.log("加载更多");
            this.$emit("pullingUp");
        },
        forceUpdate() {
            this.$nextTick(() => {
                this.$refs.scroll.forceUpdate();
            });
        },
        rebuildScroll() {
            this.$nextTick(() => {
                this.$refs.scroll.destroy();
                this.$refs.scroll.initScroll();
            });
        }
    }
};
</script>
<style scoped lang="scss">
.scroll_wrap {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;

    .list_wrap {
        height: 100%;
        position: relative;
        transform: rotate(0deg);
        overflow: hidden;
    }
}
</style>